import { getClassNameForField, volunteerFields as fields } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'

const VolunteerCreate = () => {
    const { translateFields } = useTranslationService()
    const volunteerFields = translateFields(fields, 'volunteer')

    return (
        <>
            <EditableFormPage
                title='Create Volunteer Data'
                submitUrl='admin/volunteers'
                fields={volunteerFields}
                classNameForField={getClassNameForField}
                loadingMessage='Loading...'
                errorMessage='Failed to fetch volunteer data.'
                create={true}
                navigateLink='/admin/auth/volunteers'
            />
        </>
    )
}

export default VolunteerCreate
